var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _path0, _path1, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMap = function SvgIconMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 38,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.4,
    d: "m18.383 36.883-16.62-16.62a2 2 0 0 1 .34-3.102l13.03-8.29a2 2 0 0 1 2.502.287L40.5 32.5l-7.13-2.228a2 2 0 0 0-1.646.205l-10.879 6.695a2 2 0 0 1-2.462-.289"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FED488",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "M40.5 32 21 12.5 37 2l19.5 19.5z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-map_svg__a",
    width: 37,
    height: 32,
    x: 20,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FED488",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "M40.5 32 21 12.5 37 2l19.5 19.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-map_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C8994E",
    stroke: "#AF8035",
    strokeWidth: 0.2,
    d: "M24.07 24.337c-.77.61-.528 1.046-.312 1.187.65.425.538-.112 1.3.85.763.962 1.413 1.387 1.725.2s1.162-2.488 1.811-2.063c.65.424 2.462-1.638 1.275-1.95s-1.413-1.387-1.638-2.462c-.18-.86-1.075.225-1.5.875-.358.075-1.16.356-1.5.876-.424.65-.199 1.724-1.16 2.487Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8994E",
    stroke: "#AF8035",
    strokeWidth: 0.2,
    d: "M26.918 17.189c-.09-.43 1.17-1.554 1.812-2.063-1.439-4.186 2.747-5.624 2.435-4.437s3.224-.676 4.187-1.439c.962-.762 1.811-2.062 3.96-2.513 2.15-.45 1.664 5.261 2.427 6.223s3.761-.788 4.524.174.45 2.15.138 3.337-2.886 2.288-2.548 3.9 1.3.85.988 2.037 1.413 1.386-.174 4.524-2.236 2.712-3.96 2.513c-1.726-.2-2.012 3.787-5.773 4.576-3.762.788.624-2.375 2.01-3.788 1.387-1.412-.762-.962-.987-2.037s-2.6-1.698-3.675-1.473.763.962.338 1.612-4.411.364-4.212-1.361c.2-1.725 1.811-2.063 2.661-3.363s.087-2.262-.988-2.037-.026-2.799-.25-3.874c-.226-1.074-2.8.026-2.913-.511Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8994E",
    d: "M32.758 31.672c-.367-.24.312-1.188.737-1.838 1.387-1.412 2.262.087 1.838.737-.425.65-1.925 1.525-2.575 1.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AF8035",
    strokeWidth: 0.2,
    d: "M38.791 20.31c-.216-.142-.864-.38-1.724-.2s-2.283 1.6-2.887 2.288m-.685 7.436c-.425.65-1.104 1.597-.737 1.838.65.424 2.15-.45 2.575-1.1.424-.65-.451-2.15-1.838-.738Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B24545",
    strokeDasharray: "2 1",
    d: "M35 25c1.648-.43 6.59 0 7.826-3.876.938-2.942-2.173-5.98-3.271-6.124"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#886D3B",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "M40.5 32 21 12.5 17 2l19.5 19.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FED488",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "M20.5 32 1 12.5 17 2l19.5 19.5z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-map_svg__b",
    width: 37,
    height: 32,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FED488",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "M20.5 32 1 12.5 17 2l19.5 19.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-map_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C8994E",
    stroke: "#AF8035",
    strokeWidth: 0.2,
    d: "M12.802 14.019c-.82.65-.564 1.115-.333 1.266.693.453.573-.12 1.386.906.814 1.026 1.507 1.478 1.84.212.332-1.266 1.238-2.652 1.931-2.2.694.454 2.625-1.746 1.36-2.078-1.267-.333-1.507-1.48-1.747-2.625-.192-.917-1.146.24-1.6.933-.381.08-1.236.379-1.598.933-.453.693-.213 1.84-1.239 2.653Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8994E",
    stroke: "#AF8035",
    strokeWidth: 0.2,
    d: "M15.839 6.396c-.096-.459 1.248-1.657 1.931-2.2-1.533-4.464 2.93-5.998 2.598-4.731-.333 1.266 3.438-.721 4.464-1.534s1.932-2.2 4.224-2.68S30.83.86 31.643 1.887s4.011-.84 4.824.185c.814 1.026.48 2.292.148 3.558-.333 1.267-3.078 2.44-2.718 4.16.36 1.718 1.387.905 1.054 2.171s1.506 1.479-.185 4.824c-1.692 3.346-2.385 2.893-4.224 2.68s-2.145 4.039-6.156 4.88c-4.01.84.666-2.533 2.145-4.039s-.813-1.026-1.054-2.172c-.24-1.146-2.772-1.812-3.918-1.571-1.146.24.813 1.026.36 1.719s-4.704.387-4.492-1.452c.213-1.839 1.932-2.2 2.838-3.585.906-1.387.093-2.413-1.053-2.172s-.028-2.986-.268-4.132-2.985.028-3.105-.545Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8994E",
    d: "M22.067 21.84c-.393-.256.332-1.266.785-1.96 1.48-1.506 2.413.093 1.96.786s-2.052 1.627-2.745 1.174"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AF8035",
    strokeWidth: 0.2,
    d: "M28.5 9.724c-.231-.151-.922-.405-1.84-.213-.916.192-2.433 1.707-3.077 2.44m-.73 7.93c-.454.693-1.179 1.703-.786 1.959.693.453 2.292-.48 2.745-1.174.453-.693-.48-2.292-1.96-.785Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    d: "M20.5 32 1 12.5 17 2l19.5 19.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B24545",
    strokeDasharray: "2 1",
    d: "M10 14.5c7.5-3.5 15 7 20.5 1.5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B24545",
    strokeWidth: 1.6,
    d: "m40.09 10-2.5 6.5M35 13.565 42.5 13"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#B24545",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "M35.63 8.13c0 2.865-3.777 7.053-5.833 9.12a1.815 1.815 0 0 1-2.594 0c-2.056-2.067-5.833-6.255-5.833-9.12a7.13 7.13 0 1 1 14.26 0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 8.13,
    r: 3.241,
    fill: "#000"
  })));
};
export default SvgIconMap;